import BaseApiPageableCollection from "scripts/collections/baseApiPageableCollection";
import MediaCollectionHoc from "scripts/hoc/mediaCollectionHoc";
import HybridCollectionHoc from "scripts/hoc/hybridCollectionHoc";

class HybridPageableMediaCollection extends HybridCollectionHoc(
  MediaCollectionHoc(BaseApiPageableCollection),
) {}

export default HybridPageableMediaCollection;
